(function () {
  function init() {
    const dropdown = document.getElementById('f-produto-dropdown');
    if (!dropdown) return;

    const trigger = dropdown.querySelector('.form__dropdown-trigger');
    const list = dropdown.querySelector('.form__dropdown-list');
    const label = dropdown.querySelector('.js-dropdown-label');
    const hidden = dropdown.querySelector('input[type="hidden"]');
    const options = dropdown.querySelectorAll('.form__dropdown-option');
    if (!trigger || !list || !label || !hidden || !options.length) return;

    const open = () => {
      list.classList.add('is-open');
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      list.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', event => {
      event.stopPropagation();
      if (list.classList.contains('is-open')) close();
      else open();
    });

    options.forEach(option => {
      option.addEventListener('click', () => {
        options.forEach(item => item.classList.remove('is-selected'));
        option.classList.add('is-selected');
        label.textContent = option.textContent;
        hidden.value = option.dataset.value || '';
        trigger.classList.add('has-value');
        close();
      });
    });

    document.addEventListener('click', event => {
      if (!dropdown.contains(event.target)) close();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
    });
  }

  window.HomeContatoDropdown = { init };
})();
